import { useNavigate } from "react-router-dom";
import type { ColumnDef } from "@tanstack/react-table";
import { useTerritories } from "@/hooks/use-api";
import { ListPage } from "@/components/v2/list-page";
import { DataTable } from "@/components/v2/data-table";
import { formatDate } from "@/lib/utils";

type Row = Record<string, unknown>;

const columns: ColumnDef<Row, unknown>[] = [
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => (
      <span className="font-medium transition-colors group-hover:text-[color:var(--color-accent)]">
        {(row.original.name as string) || "—"}
      </span>
    ),
  },
  {
    accessorKey: "region",
    header: "Region",
    cell: ({ row }) => {
      const region = row.original.region as string | undefined;
      return (
        <span className={region ? "" : "text-[color:var(--color-text-lo)]"}>
          {region || "—"}
        </span>
      );
    },
  },
  {
    accessorKey: "created_at",
    header: "Created",
    cell: ({ row }) => (
      <span className="text-[color:var(--color-text-md)]">
        {formatDate(row.original.created_at as string)}
      </span>
    ),
  },
];

export default function V2TerritoriesPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useTerritories();

  const territories = (data?.territories ?? []) as Row[];

  return (
    <ListPage
      title="Territories"
      subtitle={`${territories.length.toLocaleString()} total territories`}
    >
      <DataTable
        columns={columns}
        data={territories}
        isLoading={isLoading}
        onRowClick={(row) => navigate(`/territories/${row.id}`)}
        emptyMessage="No territories yet"
        emptyDescription="Define territories to group locations and assign crews."
      />
    </ListPage>
  );
}
